@if (consignment && consignment.status) {
  @if (consignmentStatus.includes(consignment.status)) {
    <div>
      <button (click)="openTrackingDialog(consignment)" class="btn btn-action btn-track" type="button">
        {{ 'orderDetails.consignmentTracking.action' | cxTranslate }}
      </button>
    </div>
  }
}